

import React, { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
// import AxiosApiCall from "../../../api/AxiosApiCall";
import AxiosApiCall from "../../api/AxiosApiCall";

const VendorWithdrawalApproval = () => {
    const [vendorName, setVendorName] = useState("");
    const [acctNumber, setAcctNumber] = useState("");
    const [amount, setAmount] = useState("");
    const [bankName, setBankName] = useState("");
    const [withdrawalMethod, setWithdrawalMethod] = useState("");
    const [reference, setReference] = useState("");
    const [processing, setProcessing] = useState("");
    const [rejection_reason, setRejectReason] = useState(null);
    const [withdrawal_id, setWithdrawalId] = useState("");
    const [admin_notes, setAdminNotes] = useState(null);
    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state?.data;
    // console.log("vrndor details", data);

    useEffect(() => {
        if (data) {
            setVendorName(data.bank_details?.account_name || "");
            setWithdrawalId(data.withdrawal_id || "");
            setAmount(data.amount || "")
            setAcctNumber(data.bank_details?.account_number || "");
            setBankName(data.bank_details?.bank_name || "")
            setWithdrawalMethod(data.withdrawal_method || "");
            setReference(data.reference)

        }
    }, [data]);

    const validateForm = () => {
        if (!processing) {
            toast.error("Aproval  is required.");
            return false;
        }
        if (processing === "reject" && !rejection_reason) {
            toast.error("Reason for disapproval is required.");
            return false;
        }


        return true;
    };

    //axios api encryption call
    const axios = AxiosApiCall();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        const formData = {
            withdrawal_id,
            admin_notes: admin_notes,
            rejection_reason: rejection_reason,
            action: processing,
        }
        // console.log("formData", formData);


        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) throw new Error("No access token found.");

            const response = await axios.post(
                ApiServices.FirstApprovalForVendorWithdrawal,
                formData,
                // { withdrawal_id, profit, profit_type },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            // console.log("api response", response);

            const { status, message } = response.data;
            if (status === 200) {
                toast.success(message, { toastId: "vendor-withdrawal-request-approval-added-success" });
                setTimeout(() => {
                    navigate("/admin/vendor/withdrawal/request");
                }, 500);
                setLoading(false); // stop loading this is for the submit button color loading
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    <section className=" body-font">
                        <div className="container px-5 pb-2 mx-auto ">
                            <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                                <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                                    <ol className="list-none p-0 inline-flex mb-2">
                                        <li className="flex items-center">
                                            <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                                Withdrawal Request reference
                                            </p>
                                            <ChevronRightIcon />
                                        </li>
                                        <li className="flex items-center">
                                            <p className="text-blue-500 hover:text-blue-600 text-orange1 pr-2">
                                                First  Approval
                                            </p>
                                        </li>

                                    </ol>
                                </nav>
                            </section>


                            <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                                <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                                    <ol className="list-none p-0 inline-flex mb-2">
                                        <li className="flex items-center">
                                            <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2 ">
                                                Reference :
                                            </p>
                                            {/* <ChevronRightIcon /> */}
                                        </li>
                                        <li className="flex items-center">
                                            <p className="text-blue-500 hover:text-blue-600 text-orange1 pr-2">
                                                {reference}
                                            </p>
                                        </li>

                                    </ol>
                                </nav>
                                <form onSubmit={handleSubmit}>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                        <input type="hidden" name="withdrawal_id" value={withdrawal_id} />
                                        <div className="w-full">
                                            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Vendor Name
                                            </label>
                                            <div className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                                                {vendorName}
                                            </div>
                                        </div>
                                        <div className="w-full">
                                            <label
                                                htmlFor="status"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                            >
                                                Bank
                                            </label>
                                            <div className="bg-gray-50 mb-2 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                                                {bankName}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                        <input type="hidden" name="withdrawal_id" value={withdrawal_id} />
                                        <div className="w-full">
                                            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Account Number
                                            </label>
                                            <div className="bg-gray-50 mb-2  border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                                                {acctNumber}
                                            </div>
                                        </div>
                                        <div className="w-full">
                                            <label
                                                htmlFor="status"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                            >
                                                Amount
                                            </label>
                                            <div className="bg-gray-50 mb-2  border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                                                {amount}
                                            </div>
                                        </div>




                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                        <input type="hidden" name="withdrawal_id" value={withdrawal_id} />
                                        <div className="w-full">
                                            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Transfer Request Method
                                            </label>
                                            <div className="bg-gray-50 mb-2   border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5 capitalize">
                                                {withdrawalMethod.replace("_", " ")}
                                            </div>
                                        </div>
                                        <div className="w-full">
                                            <label
                                                htmlFor="status"
                                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                            >
                                                <span className="text-darkGreen3">Approval</span>/
                                                <span className="text-dash3">Disapproval</span>
                                            </label>

                                            <select
                                                id="processing"
                                                value={processing}
                                                onChange={(e) => setProcessing(e.target.value)}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
                                            >
                                                <option value="" disabled>Select</option>

                                                {/* First Approval: only when status is empty/pending */}
                                                {(!data.status || data.status.trim().toLowerCase() === "pending") && (
                                                    <option value="processing">First Approval</option>
                                                )}

                                                {/* Second Approval: only when status is processing/approved */}
                                                {(data.status && ["processing", "approved"].includes(data.status.trim().toLowerCase())) && (
                                                    <option value="completed">Final Approval</option>
                                                )}

                                                {/* Reject option: always available (unless already completed/rejected) */}
                                                {(!["completed", "rejected"].includes(data.status?.trim().toLowerCase())) && (
                                                    <option value="reject">Reject</option>
                                                )}
                                            </select>

                                        </div>


                                        {processing === "reject" && (
                                            <div className="w-full col-span-2">
                                                <label htmlFor="rejection_reason" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                    Reason for Disapproval
                                                </label>
                                                <textarea
                                                    id="rejection_reason"
                                                    name="rejection_reason"
                                                    value={rejection_reason || ""}
                                                    onChange={(e) => setRejectReason(e.target.value)}
                                                    className="border border-grey3 p-2 rounded-md w-full"
                                                    rows="4"
                                                    placeholder="Enter your reason for disapproval"
                                                />

                                                {/* admin notes field */}
                                                <label htmlFor="admin_notes" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white mt-4">
                                                    Administrator Note
                                                </label>
                                                <textarea
                                                    id="admin_notes"
                                                    name="admin_notes"
                                                    value={admin_notes || ""}
                                                    onChange={(e) => setAdminNotes(e.target.value)}
                                                    className="border border-grey3 p-2 rounded-md w-full"
                                                    rows="4"
                                                    placeholder="Enter what customer needs to do"
                                                />
                                            </div>
                                        )}



                                    </div>
                                    <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                                        <Link
                                            to="/admin/vendor/withdrawal/request"
                                            className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center"
                                        >
                                            <List className="mr-2" />
                                            Back To List
                                        </Link>

                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className={`text-lGrey capitalize border-0 py-2 px-6 focus:outline-none rounded font-medium
                                             ${processing === "reject"
                                                    ? "bg-dash3 hover:bg-red-700"
                                                    : "bg-darkGreen3 hover:bg-green-700"} 
                                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                                        >
                                            {loading
                                                ? "Loading..."
                                                : processing === "reject"
                                                    ? "Disapprove"
                                                    : processing === "processing"
                                                        ? "First Approval "
                                                        : processing === "completed"
                                                            ? "Second Approval "
                                                            : "Submit"}
                                        </button>



                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
};

export default VendorWithdrawalApproval;

